// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"UpperSection_Wrapper__1s1NQ","Container":"UpperSection_Container__2uJ77","ErrorImage":"UpperSection_ErrorImage__1YmLY","ErrorText":"UpperSection_ErrorText__UczDd"};